<template>
  <SPCoreShell>
    <template #filter>
      <v-select class="mb-4" v-model="liveFilters.patientInsurance" :items="filterListData.patientInsuranceList" item-text="name" item-value="id" label="Payer" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.spp" :items="filterListData.sppList" item-text="name" item-value="id" label="SPP" multiple outline hide-details />
      <v-treeselect class="spcore-states-treeselect" :value="selectedStates" :multiple="true" :options="states" placeholder="State" @input="stateSelected" />
      <loader v-if="isFiltering.filterList" />
    </template>
    <SPCoreDonutChart
      class="flex sm12 lg6 p-4"
      title="Patient"
      :data="patientsDonutChartData"
      :filterObject="mergeFilter({ payer: null })"
      clickText="PATIENT LIST"
      :isFiltering="isFiltering.patients"
      :selected="liveFilters.payer"
      @refresh-data="loadPatientsData"
      @checked-changed="patientsSelected"
    />
    <SPCoreLineAreaChart
      class="flex sm12 lg6 p-4"
      title="New Rx Processing Time"
      :data="rxProcessingData"
      :filterObject="mergeFilter({ rxProcessing: null })"
      clickText="PATIENT"
      :isFiltering="isFiltering.rxProcessing"
      :selected="liveFilters.rxProcessing"
      @refresh-data="loadrxProcessingData"
      @checked-changed="rxProcessingSelected"
    />
    <SPCoreBarChart
      class="flex sm12 lg6 p-4"
      title="Product"
      :data="productBarChartData"
      :filterObject="mergeFilter({ product: null })"
      clickText="PRODUCT MOVEMENT"
      :isFiltering="isFiltering.product"
      :selected="liveFilters.product"
      nameField="name"
      valueField="value"
      @refresh-data="loadproductData"
      @checked-changed="productSelected"
    />
    <SPCoreDonutChart
      class="flex sm12 lg6 p-4"
      title="SPP Network"
      :data="sppNetworkDonutChartData"
      :filterObject="mergeFilter({ sppNetwork: null })"
      clickText="PHARMACY NETWORK"
      :isFiltering="isFiltering.sppNetwork"
      :selected="liveFilters.sppNetwork"
      @refresh-data="loadsppNetworkData"
      @checked-changed="sppNetworkSelected"
    />

    <div class="flex sm12 p-4">
      <div class="spcore-box w-100 p-3">
        <h2 class="hvh-h6 pb-4">Data</h2>
        <table class="spcore-brand-table spcore-big-text w-100">
          <thead>
            <tr>
              <th>SPP</th>
              <th>On Time</th>
              <th>Complete</th>
              <th>Accurate</th>
              <th>Overall Data Score</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" />
            </tr>
            <tr v-for="item in summaryData" v-bind:key="item.id">
              <td>{{ item.spp }}</td>
              <td>
                <div class="hvh-flex aling-center">
                  <SPCorePercentageCircle :value="item.ontime" />
                  <span class="ml-2">{{ item.ontime }}%</span>
                </div>
              </td>
              <td>
                <div class="hvh-flex aling-center">
                  <SPCorePercentageCircle :value="item.complete" />
                  <span class="ml-2">{{ item.complete }}%</span>
                </div>
              </td>
              <td>
                <div class="hvh-flex aling-center">
                  <SPCorePercentageCircle :value="item.accurate" />
                  <span class="ml-2">{{ item.accurate }}%</span>
                </div>
              </td>
              <td>
                <SPCorePercentageSchell class="spcore-big-text" :value="item.overallData" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </SPCoreShell>
</template>
  
<script>
import axios from '../../axios';
import { getDemographics } from '../../libraries/cohorts';
import { stringifyLiveFilters } from '../../libraries/liveFilters';
import VTreeselect from '@riophae/vue-treeselect';
import SPCoreLineAreaChart from '../../components/spcore/SPCoreLineAreaChart.vue';
import SPCoreDonutChart from '../../components/spcore/SPCoreDonutChart.vue';
import SPCoreBarChart from '../../components/spcore/SPCoreBarChart.vue';
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import SPCorePercentageCircle from '../../components/spcore/SPCorePercentageCircle.vue';
import SPCorePercentageSchell from '../../components/spcore/SPCorePercentageSchell.vue';
import { mergeFilters } from '../../libraries/common';

export default {
  title: 'Brand Summary',
  components: { VTreeselect, SPCoreLineAreaChart, SPCoreDonutChart, SPCoreBarChart, SPCoreShell, SPCorePercentageCircle, SPCorePercentageSchell, },
  data() {
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      liveFilters: { area: {} },
      isFiltering: {},
      cancelRequest: {},
      patientsDonutChartData: [
        { name: 'Pending', value: 0 },
        { name: 'Active', value: 0 }
      ],
      sppNetworkDonutChartData: [],
      summaryData: [
        { id: '1', spp: 'Accredo', ontime: 85, complete: 100, accurate: 95, overallData: 95 },
        { id: '2', spp: 'CVS', ontime: 95, complete: 95, accurate: 100, overallData: 95 },
        { id: '3', spp: 'Orsini', ontime: 95, complete: 95, accurate: 100, overallData: 95 }
      ],
      productBarChartData: [],
      rxProcessingData: { data: {}, labels: [] },
      filterListData: {},
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
      selectedStates: null,
    }
  },
  methods: {
    mergeFilter(obj) {
      return mergeFilters(this.liveFilters, obj);
    },
    loadPatientsData(filterObject) {
      if (this.cancelRequest.patients)
        this.cancelRequest.patients();
      this.$set(this.isFiltering, 'patients', true);
      axios.post('/SPCore/BrandSummary/GetBrandSummary', {
        runId: this.runId,
        brandcomponent: "Patient",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.patients = c)
      }).then((response) => {
        this.patientsDonutChartData = Object.keys(response.data)
          .filter(f => f !== 'totalPatient')
          .map(key => ({
            filterValue: key,
            name: key.capitalize(),
            value: response.data[key],
          }))
        this.isFiltering.patients = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.patients = false;
          this.disableIfTimeout(error);
        }
      });
    },
    patientsSelected(event) {
      var shouldAdd = !(this.liveFilters.payer || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'payer', (this.liveFilters.payer || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.payer.push(event.filterValue);
    },

    loadsppNetworkData(filterObject) {
      if (this.cancelRequest.sppNetwork)
        this.cancelRequest.sppNetwork();
      this.$set(this.isFiltering, 'sppNetwork', true);
      axios.post('/SPCore/BrandSummary/GetBrandSummary', {
        runId: this.runId,
        brandcomponent: "SPPNetwork",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.patients = c)
      }).then((response) => {
        this.sppNetworkDonutChartData = Object.keys(response.data)
          .map(key => ({
            filterValue: key,
            name: response.data[key].sppName.capitalize(),
            value: response.data[key].volume,
          }))
        this.isFiltering.sppNetwork = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.sppNetwork = false;
          this.disableIfTimeout(error);
        }
      });
    },
    sppNetworkSelected(event) {
      var shouldAdd = !(this.liveFilters.sppNetwork || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'sppNetwork', (this.liveFilters.sppNetwork || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.sppNetwork.push(event.filterValue);
    },

    loadproductData(filterObject) {
      if (this.cancelRequest.product)
        this.cancelRequest.product();
      this.$set(this.isFiltering, 'product', true);
      axios.post('/SPCore/BrandSummary/GetBrandSummary', {
        runId: this.runId,
        brandcomponent: "Product",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.product = c)
      }).then((response) => {
        var translations = {
          pL3: '3PL',
          sDs: 'SDs',
          hcPs: 'HCPs',
          spPs: 'SPPs',
        };

        this.productBarChartData = Object.keys(response.data)
          .map(key => ({
            filterValue: key,
            name: translations[key],
            value: response.data[key],
          }))
        this.isFiltering.product = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.product = false;
          this.disableIfTimeout(error);
        }
      });
    },
    productSelected(event) {
      var shouldAdd = !(this.liveFilters.product || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'product', (this.liveFilters.product || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.product.push(event.filterValue);
    },

    loadrxProcessingData(filterObject) {
      if (this.cancelRequest.rxProcessing)
        this.cancelRequest.rxProcessing();
      this.$set(this.isFiltering, 'rxProcessing', true);
      axios.post('/SPCore/BrandSummary/GetBrandSummary', {
        runId: this.runId,
        brandcomponent: "NewRxProcessingTime",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.rxProcessing = c)
      }).then((response) => {
        var emptyData = new Array(22).fill(0).reduce((acc, f, ind) => { acc[ind] = 0; return acc; }, []);
        var data = response.data.reduce((acc, f) => {
          if (f.noOfDays >= 21) {
            acc[21] += f.patientCount;
          } else {
            acc[f.noOfDays - 1] += f.patientCount;
          }
          return acc;
        }, emptyData);
        this.rxProcessingData = {
          // @ts-ignore
          labels: Object.keys(data).head().concat(['>=21', '>=21']),
          data: {
            Patients: Object.keys(data).map(key => ({ x: key, y: data[key] })).concat({ x: '22', y: data[21] })
          },
          originalData: response.data,
          pieces: [
            { gt: 0, lt: 7, color: 'green' },
            { gt: 7, lt: 13, color: 'yellow' },
            { gt: 13, lt: 20, color: 'orange' },
            { gt: 21, lt: 22, color: 'red' }
          ],
        }
        this.isFiltering.rxProcessing = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.rxProcessing = false;
          this.disableIfTimeout(error);
        }
      });
    },
    rxProcessingSelected(event) {
      var shouldAdd = !(this.liveFilters.lastStatus || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'rxProcessing', (this.liveFilters.rxProcessing || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.rxProcessing.push(event.filterValue);
    },

    loadFilterListData() {
      if (this.cancelRequest.filterList)
        this.cancelRequest.filterList();
      this.$set(this.isFiltering, 'filterList', true);
      axios.post('/SPCore/BrandSummary/GetBrandSummary', {
        runId: this.runId,
        brandcomponent: "FilterListData",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.filterList = c)
      }).then((response) => {
        this.filterListData = response.data;
        this.isFiltering.filterList = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.filterList = false;
          this.disableIfTimeout(error);
        }
      });
    },
    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },
    disableIfTimeout(error) {
      if (error.response.status === 504) {
        this.alert('Error', 'Loading of data failed. Please reload page to try loading data again.');
      }
    },
  },
  computed: {
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCoreBrandSummary'] = this;
    this.loadFilterListData();
  },
}
</script>

<style lang="scss" scoped>
.spcore-brand-table {
  // font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;

  td,
  th {
    border: 0px solid #ddd;
    padding: 8px;
    // font-weight: bold;
  }

  tbody tr:nth-child(odd):not(:first-child) {
    background-color: rgba(140, 202, 200, 0.1);
  }

  tr:hover {
    background-color: #ddd;
  }

  th {
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;
    background-color: rgba(140, 202, 200, 0.25);
  }

  th:not(:first-child),
  td:not(:first-child) {
    padding-left: 20px;
  }
  td:not(:last-child) {
    border-right: 1px solid #8ccac8;
  }
}

.circle {
  min-width: 21px;
  min-height: 21px;
}
</style>